import axios from "axios";

const RestfulProvider = axios.create({
    baseURL: "https://api-kiosk-sandbox.aavgo.com/backend",
    timeout: 10000,
});
//https://api-kiosk-sandbox.aavgo.com/backend/staff/v3/kiosk/addChatbotReviews
const headers = {
    Accept: "application/json",
    "Content-type": "application/json",
    language: "en",
};

const subUrl = "/staff/v3/kiosk";

class ChatBotService {
    addChatbotReviews = (data) =>
        RestfulProvider.post(`${subUrl}/addChatbotReviews`, data, headers);
}
export default new ChatBotService();
